<script setup lang="ts">
defineProps({
    // Prop per controllare la visibilità del loader
    isLoading: {
        type: Boolean,
        required: true
    }
});
onMounted(()=>{
})
</script>
<template>
    <!--Loader-->
    <div v-if="isLoading" class="xboot-loader">
        <div class="loader-wrapper">
            <div class="loader-content">
                <div class="loader-dot dot-1"></div>
                <div class="loader-dot dot-2"></div>
                <div class="loader-dot dot-3"></div>
                <div class="loader-dot dot-4"></div>
                <div class="loader-dot dot-5"></div>
                <div class="loader-dot dot-6"></div>
                <div class="loader-dot dot-7"></div>
                <div class="loader-dot dot-8"></div>
                <div class="loader-dot dot-center"></div>
            </div>
        </div>
    </div>
    <!-- Loader end -->  
</template>